/** Only the MCP consent page may be a post-login target (no open redirect). */
export const SAFE_NEXT_PATH_PATTERN = /^\/verbinden(\?[A-Za-z0-9_=&%.-]*)?$/

const MAX_NEXT_LENGTH = 1000

/** Validates the raw string: no decoding, no normalisation. */
export function isSafeNextPath(next: unknown): next is string {
  return typeof next === 'string' && next.length <= MAX_NEXT_LENGTH && SAFE_NEXT_PATH_PATTERN.test(next)
}

/** The given path when safe, otherwise the home page. */
export function safeNextPath(next: string | null | undefined): string {
  return isSafeNextPath(next) ? next : '/'
}
